import React from 'react';
import { Outlet } from 'react-router-dom';

import './style.sass';

import plusIcon from 'assets/img/icons/plus-icon.svg';

import { SideMenu } from 'app/components/common/SideMenu';
import { Header } from '../../components/common/Header';
import { useBreakpointType } from 'app/services/breakpoints';
import { BreadCrumbs } from 'app/components/common/BreadCrumbs';
import { Button } from 'app/components/common/Button';
import { Routes } from 'src/types/routes';
import { AppViewModel } from 'app/viewModels';

export const DefaultLayout = () => {
    const { isDesktop } = useBreakpointType();

    const isAdmin = AppViewModel.Instance.userRole.isAdmin;

    return (
        <section className="default-layout">
            <article className="default-layout__left-wrapper">
                <SideMenu />
            </article>

            <article className="default-layout__right-wrapper">
                <Header />

                {!isDesktop && (
                    <div className="default-layout__extra-panel">
                        <BreadCrumbs />

                        {!isAdmin &&
                            <Button
                                text="create campaign"
                                className="default-layout__create-btn"
                                iconSrc={plusIcon}
                                size='big'
                                to={Routes.Campaigns}
                            />
                        }
                    </div>
                )}

                <article className="default-layout__outlet">
                    <Outlet />
                </article>
            </article>
        </section>
    );
};
